import { render, staticRenderFns } from "./event-management-register.vue?vue&type=template&id=687b205c&scoped=true&"
import script from "./event-management-register.vue?vue&type=script&lang=js&"
export * from "./event-management-register.vue?vue&type=script&lang=js&"
import style0 from "./event-management-register.vue?vue&type=style&index=0&id=687b205c&prod&lang=css&"
import style1 from "./event-management-register.vue?vue&type=style&index=1&id=687b205c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687b205c",
  null
  
)

export default component.exports